import { Button, Modal } from '../../../../../components'
import { useAppDispatch } from '../../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../../redux/slices/showNotificationSlice'
import { deleteCalendarEvent } from '../../api'
import { DelCalendarModalProps } from '../../types'
import { deleteEventsFromList } from '../../slice/eventSlice'

const DelCalendarEvent = ({ show, onClose, data }: DelCalendarModalProps) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Delete Event"
            body={
                <>
                    <p className="del-desc">
                        Are you sure you want to delete this Event ?
                    </p>
                    <div className="footer-block">
                        <Button
                            type="submit"
                            onClick={async () => {
                                const response = await deleteCalendarEvent(
                                    data.id
                                )
                                if (response) {
                                    dispatch(
                                        deleteEventsFromList({
                                            id: data.id,
                                        })
                                    )
                                    dispatch(
                                        SHOW_NOTIFICATION({
                                            type: 'success',
                                            message:
                                                'Event deleted successfully',
                                        })
                                    )
                                }
                                onClose(false)
                            }}
                        >
                            YES
                        </Button>
                        <Button
                            type="submit"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DelCalendarEvent
